import axios from 'axios'
import { createAxiosInstance } from 'common/config/axios.config'
import { getMallConfig } from 'common/config/mall'
import { OrderStatusCount, RecentlyShoppingInfo } from 'domain/goods'
import {
  ChangePaswordDto,
  NoticeModel,
  ProfileModifyDto,
  UserAddressProps,
} from 'domain/profile'
import { OrderModel } from 'domain/purchase/models'
import { OrderResponseDTO } from 'domain/purchase/response.dto'
import { ErrorHandler } from 'common/utils/error-handler.util'

const profileAxiosInstance = createAxiosInstance(true)

export function fetchProductDetail(productId: number | string) {
  return profileAxiosInstance
    .get(`/products/${productId}/detail`)
    .then((response) => response.data)
}

export function getRecentShoppingInfoFetcher(): Promise<RecentlyShoppingInfo> {
  return profileAxiosInstance
    .get<{ orderList?: OrderResponseDTO[]; status?: OrderStatusCount }>(
      `/profile/shopping/recent`,
    )
    .then((response) => {
      return {
        orderList: response.data.orderList?.map(
          (orderResponseDto) => new OrderModel(orderResponseDto),
        ),
        status: response.data.status,
      }
    })
    .catch((error) => {
      throw ErrorHandler.handleApiError(error);
    })
}

export async function getMyDeliveryAddressFetcher(): Promise<
  UserAddressProps[]
> {
  return await profileAxiosInstance
    .get(`/profile/address`)
    .then(async (response) => {
      return await response.data
    })
    .catch((error) => {
      throw ErrorHandler.handleApiError(error);
    })
}

export async function deleteAddressFetcher(data: Int32List) {
  return await profileAxiosInstance
    .post(`/profile/address/delete`, data)
    .then(async (response) => {
      return await response.data
    })
    .catch((error) => {
      throw ErrorHandler.handleApiError(error);
    })
}
export async function ChangePasswordFetcher(data: ChangePaswordDto) {
  return await profileAxiosInstance
    .put(`/profile/password/change`, data)
    .then(async (response) => {
      return await response.data
    })
}
export async function UserInfoModifyFetcher(data: ProfileModifyDto) {
  return await profileAxiosInstance
    .put(`/profile/modify`, data)
    .then(async (response) => {
      return await response.data
    })
}
export async function deleteChangeDefaultAddressFetcher(addressId: number) {
  return await profileAxiosInstance
    .put(`/profile/address/default`, { default_address_id: addressId })
    .then(async (response) => {
      return await response.data
    })
}

export function fetchOrderList(
  startDate: string,
  endDate: string,
): Promise<OrderModel[]> {
  return profileAxiosInstance
    .get<
      OrderResponseDTO[]
    >(`/profile/order?start-date=${startDate}&end-date=${endDate}`)
    .then((response) =>
      response.data.map((orderResponseDto) => new OrderModel(orderResponseDto)),
    )
}

export function getOrderFetcher(orderId: number): Promise<OrderModel> {
  return profileAxiosInstance
    .get<OrderResponseDTO>(`/profile/order/${orderId}`)
    .then((response) => new OrderModel(response.data))
}

export function fetchNoticeList(): Promise<NoticeModel[]> {
  const mallId = localStorage.getItem('mall-id') || String(getMallConfig().id);
  
  return profileAxiosInstance
    .get<any[]>('/admin/announcements', {
      params: { mall_id: mallId }
    })
    .then((response) =>
      response.data.map(
        (noticeResponseDto) => new NoticeModel(noticeResponseDto),
      ),
    )
    .catch(() => {
      console.error('공지사항 목록을 가져오는데 실패했습니다.');
      return [];
    });
}

export function getNoticeFetcher(noticeId: number): Promise<NoticeModel> {
  const mallId = localStorage.getItem('mall-id') || String(getMallConfig().id);
  
  return profileAxiosInstance
    .get(`/admin/announcements/${noticeId}`, {
      params: { mall_id: mallId }
    })
    .then((response) => new NoticeModel(response.data))
    .catch(() => {
      console.error('МЭДЭЭЛЭЛ АВАХАД АМЖИЛТГҮЙ БОЛЛОО');
      return new NoticeModel({id: noticeId, title: 'МЭДЭЭЛЭЛ', content: 'АГУУЛГА АВАХ БОЛОМЖГҮЙ'});
    });
}

// 최신 공지사항 가져오기
export function getLatestNoticeFetcher(): Promise<NoticeModel> {
  const mallId = localStorage.getItem('mall-id') || String(getMallConfig().id);
  
  return profileAxiosInstance
    .get('/admin/announcements/last', {
      params: { mall_id: mallId }
    })
    .then((response) => new NoticeModel(response.data))
    .catch(() => {
      console.error('최신 공지사항을 가져오는데 실패했습니다.');
      return new NoticeModel({id: 0, title: '공지사항이 없습니다.', content: ''});
    });
}
